import clsx from 'clsx'
import { Trans, useTranslation } from 'react-i18next'

import { Price } from 'src/components/Price/Price'
import { getCalculatedPrices } from 'src/functions/price/getCalculatedPrices'

import styles from './BuyBoxPrice.module.scss'

import type { Product, ProductVariant } from 'src/data/graphql-generated'

interface BuyBoxPriceProps {
  variant: ProductVariant
  isSubscription?: boolean
  productType: Product['productType']
}

export const BuyBoxPrice = ({ isSubscription, variant, productType }: BuyBoxPriceProps) => {
  const { t } = useTranslation()

  const { price, compareAtPrice, subscriptionPrice } = getCalculatedPrices({
    variant,
    donationQuantity: 1,
  })
  const isCoffee = productType === 'coffee'
  const priceToDisplay = isSubscription ? subscriptionPrice : price
  // eslint-disable-next-line no-nested-ternary
  const compareAtPriceToDisplay = isSubscription ? (isCoffee ? price : undefined) : compareAtPrice

  const savedAmount = compareAtPriceToDisplay?.amount && {
    amount: (priceToDisplay.amount - compareAtPriceToDisplay.amount) * -1,
    currencyCode: priceToDisplay.currencyCode,
  }

  const forSubscription = savedAmount && isSubscription

  return (
    <div className={clsx(styles.wrapper)}>
      <span className={styles.price}>
        {compareAtPriceToDisplay && (
          <span className={styles.oldPrice}>
            <Price price={compareAtPriceToDisplay} />
          </span>
        )}
        <span className={clsx(styles.price, compareAtPriceToDisplay && styles.discounted)}>
          <Price price={priceToDisplay} />
        </span>
      </span>
      {forSubscription && (
        <span className={styles.saved}>
          <Trans
            i18nKey={t('pdp.subscription.saved')}
            components={[<Price key="saved-amount" price={savedAmount} />]}
          />
        </span>
      )}
    </div>
  )
}
